var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandyCane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 2C10.4939 2.18743 8.93179 3.02555 7.80853 4.2691L11.2245 6.55092C11.5278 6.32738 11.8747 6.15966 12.25 6.06287V2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 6.01687C13.947 6.05431 14.1366 6.11267 14.3165 6.18955L17.7961 3.8652C16.7143 2.84523 15.3086 2.16635 13.75 2V6.01687Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22C6.89543 22 6 21.1028 6 19.996V18.7435H10V19.996C10 21.1028 9.10457 22 8 22Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.2406H6V14.7356H10V17.2406Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.2326H6V10.7276H10V13.2326Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.97414V9.22464H10V8.97414C10 8.52697 10.0975 8.1026 10.2722 7.72119L6.92577 5.48578C6.3368 6.51322 6 7.70427 6 8.97414Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5251 7.18861L18.779 5.01501C19.5493 6.14177 20 7.50522 20 8.97415V9.17455C20 9.61725 19.6418 9.97614 19.2 9.97614H17.2308C16.551 9.97614 16 9.42402 16 8.74293C16 8.16699 15.8249 7.63203 15.5251 7.18861Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandyCane);
export default __webpack_public_path__ + "static/media/candy-cane.cdb49e0fd6cb7e58f7119c5486031715.svg";
export { ForwardRef as ReactComponent };